<div class="container d-flex mx-auto flex-column main-container">
  <app-navbar></app-navbar>
  <main role="main" class="fill">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
